export default __webpack_public_path__ + "static/media/spr-components-dark.78046667.png";